define('PLPColorImages'
  , [
  ]
  , function
    (
  ) {
    'use strict';
    return {
      mountToApp: function mountToApp(container) {
        var PLP = container.getComponent('PLP')
          , Environment = container.getComponent('Environment')
          , Layout = container.getComponent('Layout')
          , customColorId = 'custitem9';

        if (customColorId) {
          Layout.addToViewContextDefinition('Facets.ItemCell.View', 'value', 'string', function thumbnail(context) {
            var model = _.find(PLP.getItemsInfo(), function (item) {
              return item.internalid == context.itemId
            })
              , thumbnail = context.thumbnail
              , images = model.itemimages_detail ? model.itemimages_detail : ''
              , filters = _.find(PLP.getFilters(), function (filter) {
                return filter.id == customColorId
              });

              if (images && filters && filters.value[0].replace(/-SLASH-/g, "").replace(/-|~/g, '')) {
                  var value =filters.value;
              }
            return value;
          });


          Layout.addToViewContextDefinition('Facets.ItemCell.View', 'thumbnail', 'string', function thumbnail(context) {
            var model = _.find(PLP.getItemsInfo(), function (item) {
              return item.internalid == context.itemId
            })
              , thumbnail = context.thumbnail
              , images = model.itemimages_detail ? model.itemimages_detail : ''
              , filters = _.find(PLP.getFilters(), function (filter) {
                return filter.id == customColorId
              });

            if (images && filters && filters.value[0].replace(/-SLASH-/g, "").replace(/-|~/g, '') && images[filters.value.replace(/-SLASH-/g, "").replace(/-|~/g, '')]) {
              if (images[filters.value.replace(/-SLASH-/g, "").replace(/-|~/g, '')] && images[filters.value.replace(/-SLASH-/g, "").replace(/-|~/g, '')]['Studio.Main'].urls) {
                thumbnail = images[filters.value.replace(/-SLASH-/g, "").replace(/-|~/g, '')]['Studio.Main'].urls[0]
              }
            }
            else if(images && filters && filters.value[0] && filters.value.replace(/-%28/g, '(').replace(/%29/g, ')')){
              thumbnail = images[filters.value.replace(/-%28/g, '(').replace(/%29/g, ')')]['Studio.Main'].urls[0]
            }

            return thumbnail;
          });
          Layout.addToViewContextDefinition('Facets.ItemCell.View', 'url', 'string', function url(context) {
            var model = _.find(PLP.getItemsInfo(), function (item) {
              return item.internalid == context.itemId
            })
              , filters = _.find(PLP.getFilters(), function (filter) {
                return filter.id == customColorId
              })
              , existingUrl = context.url
              , fields = model.itemoptions_detail ? model.itemoptions_detail.fields : ''
              , fieldColors = fields ? _.find(fields, function (option) {
                return option.sourcefrom == customColorId
              }) : ''
              , fieldColorValues = fieldColors ? fieldColors.values : '';

            if (fieldColorValues && filters && filters.value[0].replace(/-SLASH-/g, "").replace(/-|~/g, '')) {
              var url = '';
              _.each(fieldColorValues, function (value) {
                const label = value.label.replace(/[-/' ']/g, '');
                if (label == filters.value.replace(/-SLASH-/g, "").replace(/-|~/g, '')) {
                  url = value;
                }else if(label == filters.value.replace(/-%28/g, '(').replace(/%29/g, ')')){
                  url = value;
                }
              });
              if (url) {
                return url.url
              }
            }
            else {
              return existingUrl
            }
          });
        }
      }
    }
  });
